import { httpClient } from '@/shared/api/httpClient';

export type ServicoResumo = {
  id: string;
  codigo: string;
  nome: string;
  precoUnitario: number;
  ativo: boolean;
  /** true enquanto o cadastro/edição não foi confirmado pelo servidor. */
  syncPendente: boolean;
};

export type CriarServicoRequest = {
  codigo?: string | null;
  nome: string;
  precoUnitario: number;
};

export type CriarServicoResponse = { id: string };

export type AtualizarServicoRequest = {
  nome: string;
  precoUnitario: number;
  ativo: boolean;
};

export const servicosApi = {
  listar: () => httpClient.get<ServicoResumo[]>('/api/servicos'),
  criar: (cmd: CriarServicoRequest) =>
    httpClient.post<CriarServicoResponse>('/api/servicos', cmd),
  atualizar: (id: string, cmd: AtualizarServicoRequest) =>
    httpClient.put<void>(`/api/servicos/${id}`, cmd),
  excluir: (id: string) => httpClient.delete<void>(`/api/servicos/${id}`),
};
